import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Responsive from '../../components/Responsive';
import MessengerView from '../../components/views/messenger/MessengerView';
import FormViewer from '../../components/FormViewer';
import { createMessengerInfo, translate } from '../../utils/useful';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import HttpServices from '../../utils/Http.services';
import store from '../../stores/storeConfig';
import socketServices from '../../utils/socket.services';
import MessengerList from '../../components/views/messenger/MessengerList';

class MessengerUserView extends Component {

    state = {
        stage: 1,
        formHeader: [
            { key: 'text-2', type: 'StaticText', col: '12', information: { label: '{{lang}}Welcome to Yonnect. Please fill in the form below before starting the chat.', fontSize: 16, color: '#000', fontWeight: '500', marginBottom: 15 }, showMain: false },
            { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}Name', placeholder: '{{lang}}Enter your name', required: true } },
            { key: 'phone', type: 'PhoneInput', information: { label: '{{lang}}phonenumber', placeholder: '{{lang}}phonenumber', required: true } },

        ],
        showMessengerList: false
    }

    componentDidMount() {
        let passLogin = false
        if (this.props.user.loggedin || this.props.user.anonymousInfo?._id) {
            passLogin = true
        }
        this.setState({ passLogin }, () => {
            if (passLogin) {
                this.init()
            }
        })

        // this.props.init()
        // this.props.selectPotentialUser()
        // this.setState({ width: window.innerWidth })
        // window.addEventListener('resize', this.updateWidth)
        // this.props.updateWidth()
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data)) {
            // setTimeout(() => {
            // this.props.init()
            // }, 500);
        }


        if (JSON.stringify(this.props.user?.info?._id) !== JSON.stringify(prevProps.user?.info?._id)) {
            this.init()
        }
        // if (prevProps.height != this.props.height) {
        //     this.props.updateWidth()
        // }
    }



    createAnonymousUser = () => {
        let data = this.form.getForm()
        if (data) {
            // console.log('data', data)
            HttpServices.request('anonymousCheck', data, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                // currentApplet
                store.dispatch(actions.setAnonymousUser(fetchResult.info, fetchResult.accessToken))
                this.props.setData('currentApplet', fetchResult.applet, 'MessengerApplet', () => {
                    this.setState({ passLogin: true, tempUser: fetchResult.info })
                })

            })
        }
    }


    init = () => {

        // console.log("INIT")
        let myId = this.props.user?.info?._id
        this.setState({ myId }, () => {
        })

        let frame = this.props.page
        this.fetchMessenger(frame)
        let showMessengerList = false
        let scope = null

        if (frame.mode == 'support') {
            showMessengerList = true
            scope = { type: 'frame', item: this.props.page }
        }

        this.setState({ scope, showMessengerList })

    }



    fetchMessenger = (frame) => {

        let frameId = frame?._id ?? frame

        HttpServices.request('getMessengerUserPerspective', { frame: frameId }, (fetchResult, fetchError) => {


            // console.log(fetchResult)

            if (fetchError) {

                return
            }

            let myFrames = fetchResult.myFrames

            if (Array.isArray(fetchResult.conversations) && fetchResult.conversations.length > 0) {

                this.props.actions.addMessengers(fetchResult.conversations, false, this.state.myId)

                // console.log("TPP1")

                // console.log("vv", frame)

                setTimeout(() => {

                    if (fetchResult.conversations.length == 1) {
                        this.setMessenger(createMessengerInfo(fetchResult.conversations[0], this.state.myId))
                    }

                    if (this.props.changePage) {

                        let newLink = []
                        if (this.props.inApplet) {
                            newLink = [this.props.windowData.path[this.props.baseUrl.length]]
                        }


                        this.props.changePage(newLink, { id: fetchResult.conversations[0]?._id })
                    }

                }, 200)

            } else {

                console.log("TPP2")

                if (Array.isArray(myFrames) && myFrames.length > 0) {

                    this.setPotentialUser(fetchResult?.info, fetchResult?.info, myFrames[0])

                }
            }

            this.setState({ myFrames })


        })

    }


    setPotentialUser = (item, frame, myFrame) => {

        // console.log(item)
        let potentialUser = item.hub
        this.setState({ stage: 2, potentialUser, messenger: null, potentialFrame: frame, myPotentialFrame: myFrame })
        this.updateWidth()

    }


    setMessenger = (messenger, cb) => {

        this.setState({ topics: [], messenger: messenger }, () => {
            if (cb) {
                cb()
            }
        })

    }


    updateWidth = () => {
        if (this.MessengerView) {
            let bound = this.MessengerView.getBoundingClientRect()
            this.setState({ mwidth: bound.width, mheight: bound.height })
        }
    }



    sendNotif = (type, value, messenger, time = 1, tryTime = 0, cb) => {
        setTimeout(() => {
            if (socketServices.socket?.connected) {
                socketServices.emit('handleNotif', { type, value, messenger }, null, (info, err) => {
                    if (cb)
                        cb()
                })
            }
            else {
                if (tryTime < 10) {
                    this.sendNotif(type, value, messenger, time + 5, tryTime + 1, cb)
                }
            }
        }, time * 1000);
    }


    openMessenger = (messenger) => {

        let potentialUser = messenger.hub
        // console.log('openMessenger', messenger)

        this.setMessenger(messenger, () => {
            this.setState({ stage: 2, potentialUser, potentialFrame: null, myPotentialFrame: null }, () => {

                this.updateWidth()
                let id = messenger?._id

                if (this.props.changePage) {


                    let newLink = []
                    if (this.props.inApplet) {
                        newLink = [this.props.windowData.path[this.props.baseUrl.length]]
                    }


                    this.props.changePage(newLink, { id: id })


                    // let newLink = []
                    // if (this.props.inApplet) {
                    //     newLink = [this.props.windowData.path[this.props.baseUrl.length]]
                    // }

                    // newLink.push(id)
                    // this.props.changePage(newLink)
                } else {


                }
            })
        })


    }


    startNewTicket = () => {
        let frame = this.props.frame ?? this.props.page
        let item = frame

        // console.log('startNewTicket', item)
        // console.log('startNewTicket', this.props.variables)


        let myFrame = this.state.myFrames[0]
        let potentialUser = this.props.variables?.hub//item.hub
        // console.log('potentialUser', potentialUser, item, myFrame)
        this.setState({ stage: 2, potentialUser, messenger: null, potentialFrame: frame, myPotentialFrame: myFrame })
        // this.setMessenger(item, () => {
        // this.props.updateWidth()

        // console.log('startNewTicket1')

        let newLink = []
        newLink = [this.props.windowData.path[this.props.baseUrl.length]]

        // console.log('startNewTicket2')

        // console.log(newLink)


        this.props.changePage(newLink, {})
        // let id = 'h=' + potentialUser?.username
        // console.log(id)
        // this.props.changePage(null, { f: frame._id, h: potentialUser?.username, })
    }


    render() {
        return (
            <div className="w-100 d-flex Messenger window-content-radius h-100"  >
                <div className=' w-100  h-100 bg-white window-content-radius'>
                    <div className="d-flex m-0 h-100 w-100" >
                        {/* <Responsive height="100%" width={this.props.width} media={{ xs: this.state.stage == 1 ? "12" : "none", sm: this.state.stage == 1 ? "12" : 'none', md: '4', lg: "4", xl: "3" }}>
                            <div className=' h-100 scroll-no-scrollbar  w-100 d-flex flex-column'>
                                <MessengerList variables={variables} page={this.props.page} openOne={this.openOne} closeOne={this.closeOne} messenger={this.state.messenger} width={this.props.width} />
                            </div>
                        </Responsive> */}
                        {this.state.passLogin ? (
                            <div className="d-flex m-0 h-100 w-100" >

                                {this.state.showMessengerList && (
                                    <Responsive height="100%" width={this.props.width} media={{ xs: !this.state.messengerInfo ? "12" : "none", sm: !this.state.messengerInfo ? "12" : 'none', md: '4', lg: "4", xl: "3" }}>
                                        <div className=' h-100 scroll-no-scrollbar  w-100 d-flex flex-column'>

                                            <MessengerList scope={this.state.scope} showHeader={this.showHeader}
                                                language={this.props.language}
                                                selectApplet={this.selectApplet}
                                                isApplet={this.props.isApplet}
                                                variables={this.props.variables}
                                                page={this.props.page}
                                                frame={this.props.page}
                                                adminView={this.props.adminView}
                                                startNewTicket={this.startNewTicket}
                                                openOne={this.openOne} openMessenger={this.openMessenger} closeOne={this.closeOne} setMessenger={this.setMessenger} messenger={this.state.messenger} width={this.props.width} functionsHandler={this.functionsHandler} applet={this.props.applet} colors={this.props.colors} />

                                        </div>
                                    </Responsive>
                                )}

                                <Responsive width={this.props.width} height="100%" media={!this.state.showMessengerList ? { xs: '12' } : { xs: this.state.messengerInfo ? "12" : 'none', sm: this.state.messengerInfo ? "12" : 'none', md: '8', lg: "8", xl: "9" }}>
                                    <div ref={el => this.MessengerView = el} className="w-100 h-100 position-relative p-0 flexc flex-column" style={{ backgroundColor: '#f0f0f0' }}>
                                        <div className="w-100 h-100 flex-1" style={{ maxWidth: 700, backgroundColor: '#fff' }} >
                                            <MessengerView
                                                frame={this.props.page}
                                                variables={this.props.variables}
                                                setMessenger={this.setMessenger}
                                                sendNotif={this.sendNotif}
                                                topics={this.state.topics}
                                                messenger={this.state.messenger}
                                                potentialUser={this.state.potentialUser}
                                                potentialFrame={this.state.potentialFrame}
                                                myPotentialFrame={this.state.myPotentialFrame}
                                                height={this.state.mheight}
                                                currentApplet={this.props.currentApplet}
                                                adminView={false}
                                                tempUser={this.state.tempUser}
                                                showClose={false}
                                                setTopics={this.state.setTopics}
                                                userPerspective={true}


                                                // showBack={conditionalWidth(this.props.width, { xs: true, sm: true, md: true, lg: false })}
                                                close={() => this.setState({ showMessenger: false }, () => this.props.updateWidth())}
                                                askForForm={false}
                                                closeOne={this.props.closeOne}
                                                width={this.props.width}
                                                language={this.props.language}
                                                colors={this.props.colors}
                                                applet={this.props.applet}
                                            />
                                        </div>
                                    </div>
                                </Responsive>
                            </div>
                        ) : <>
                            <Responsive width={this.props.width} height="100%" media={{ xs: "12", sm: "12", md: '12', lg: "12", xl: "12" }}>
                                <div className="w-100 p-0" >
                                    {/* <div className="w-100 h-100" ></div> */}
                                    <FormViewer ref={e => this.form = e} headers={this.state.formHeader} />
                                    <div className='flexcc'>
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={this.createAnonymousUser}
                                            title={translate('start the chat')}
                                            icon='/assets/icons/plus-white.svg'
                                            textColor={this.props.colors?.textColor}
                                            invert={this.props.colors?.iconInvert}
                                            bg={this.props.colors ? `linear-gradient(90deg, ${this.props.colors?.primaryColor}, ${this.props.colors?.secondaryColor})` : 'linear-gradient(to right, #5856D6, #7D7AFF)'}
                                        />
                                    </div>
                                </div>
                            </Responsive>
                        </>}
                    </div>
                </div>
            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MessengerUserView);